import api from "API";
import * as Params from "API/params";

import * as EntityCustomAttributes from "./payloads";

export const entityCustomAttributesEndpoint = `/organisations/:org/entity-custom-attributes`;

const extendedEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    entityCustomAttributes: builder.query<
      EntityCustomAttributes.GetEntityCustomAttributes,
      Params.GenericParamMap
    >({
      query: () => ({
        url: entityCustomAttributesEndpoint,
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useEntityCustomAttributesQuery } = extendedEndpoints;
